function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.595,14.756h-0.021c0.039,0.084,0.083,0.166,0.121,0.252C38.658,14.926,38.633,14.838,38.595,14.756z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.298,16.514c-0.049-0.146-0.117-0.281-0.17-0.425c0.052,0.142,0.107,0.281,0.155,0.425H39.298z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.638,12.996c-0.042-0.068-0.097-0.127-0.14-0.193c0.041,0.063,0.078,0.129,0.118,0.193H37.638z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.779,18.271h-0.007c0.005,0.025,0.014,0.049,0.019,0.074C39.786,18.321,39.784,18.296,39.779,18.271z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.595,28.821h-0.021c-0.054,0.113-0.107,0.226-0.163,0.338C38.469,29.044,38.54,28.938,38.595,28.821z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.262,32.461c-0.278,0.33-0.568,0.65-0.871,0.958C35.693,33.111,35.984,32.793,36.262,32.461z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.638,30.582c0.07-0.113,0.124-0.238,0.191-0.353c-0.07,0.118-0.141,0.236-0.214,0.353H37.638z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.372,11.237H36.37c0.022,0.027,0.041,0.058,0.063,0.085C36.411,11.295,36.395,11.264,36.372,11.237z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.298,27.064c0.021-0.065,0.037-0.135,0.059-0.2c-0.022,0.067-0.051,0.133-0.073,0.2H39.298z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.486,26.417c0.091-0.313,0.175-0.63,0.248-0.951c-0.001-0.001-0.002-0.003-0.003-0.004 C39.659,25.783,39.577,26.103,39.486,26.417z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.772,30.639c-0.226,0-0.408,0.181-0.408,0.408c0,0.224,0.183,0.406,0.408,0.406s0.407-0.183,0.407-0.406 C61.18,30.819,60.998,30.639,60.772,30.639z M60.852,31.28l-0.071-0.187H60.7v0.187h-0.111v-0.47h0.199 c0.042,0,0.085,0,0.121,0.023c0.038,0.026,0.061,0.072,0.061,0.117c0,0.055-0.032,0.104-0.082,0.123l0.086,0.206H60.852z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M65.688,0H3.701C1.656,0,0,1.658,0,3.701v36.175c0,2.044,1.656,3.7,3.701,3.7h61.987c2.043,0,3.699-1.656,3.699-3.7V3.701 C69.388,1.658,67.731,0,65.688,0z M60.772,31.582c-0.296,0-0.537-0.24-0.537-0.535c0-0.298,0.241-0.539,0.537-0.539 c0.297,0,0.536,0.241,0.536,0.539C61.309,31.342,61.069,31.582,60.772,31.582z M45.843,38.396c-4.292,0-8.201-1.629-11.149-4.299 c0.136-0.123,0.262-0.256,0.394-0.383c-2.989,2.893-7.055,4.682-11.542,4.682c-9.172,0-16.606-7.438-16.606-16.608 S14.373,5.182,23.545,5.182c4.29,0,8.188,1.641,11.136,4.312c0.004-0.004,0.008-0.009,0.013-0.013 c2.947-2.67,6.857-4.299,11.149-4.299c9.17,0,16.606,7.436,16.606,16.606S55.013,38.396,45.843,38.396z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.759,30.895H60.7v0.12h0.061c0.022,0,0.046,0.001,0.068-0.009c0.017-0.011,0.026-0.035,0.026-0.055 c0-0.019-0.011-0.039-0.026-0.049C60.809,30.891,60.778,30.895,60.759,30.895z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.772,30.508c-0.296,0-0.537,0.241-0.537,0.539c0,0.295,0.241,0.535,0.537,0.535c0.297,0,0.536-0.24,0.536-0.535 C61.309,30.749,61.069,30.508,60.772,30.508z M60.772,31.453c-0.226,0-0.408-0.183-0.408-0.406c0-0.228,0.183-0.408,0.408-0.408 s0.407,0.181,0.407,0.408C61.18,31.271,60.998,31.453,60.772,31.453z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.97,30.951c0-0.045-0.022-0.091-0.061-0.117c-0.036-0.023-0.079-0.023-0.121-0.023h-0.199v0.47H60.7v-0.187h0.08 l0.071,0.187h0.122l-0.086-0.206C60.938,31.055,60.97,31.006,60.97,30.951z M60.829,31.006c-0.022,0.01-0.046,0.009-0.068,0.009 H60.7v-0.12h0.059c0.02,0,0.05-0.004,0.07,0.008c0.016,0.01,0.026,0.03,0.026,0.049C60.855,30.971,60.846,30.995,60.829,31.006z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.472,21.375c0-0.455-0.313-0.623-1.154-0.623c-0.883-0.01-1.61,0.21-1.91,0.309c0.013-0.077,0.119-0.734,0.189-1.166 c-0.147,0.039-0.293,0.076-0.459,0.125c0,0-0.229,1.426-0.249,1.539c0.3-0.098,1.025-0.318,1.908-0.307 c0.772,0,1.086,0.153,1.136,0.525c0.147,0.008,0.305,0.021,0.469,0.043C20.458,21.594,20.472,21.497,20.472,21.375z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.038,25.449c-0.455,0.563-1.063,0.828-1.89,0.828c-0.978,0-1.646-0.763-1.646-1.87c0-0.614,0.16-1.132,0.46-1.544 c-0.45,0.322-0.753,0.769-0.89,1.328l-0.058,0.35c-0.014,0.119-0.033,0.235-0.033,0.363c0,1.109,0.671,1.873,1.647,1.873 c0.827,0,1.435-0.268,1.891-0.828l-0.034,0.71h1.494c0.009-0.104,0.032-0.287,0.062-0.501h-1.036L20.038,25.449z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.323,23.755c0.244-0.106,0.543-0.176,0.942-0.176c0.131,0,0.212,0.005,0.403,0.028 c-0.014,0.438-0.125,0.813-0.302,1.102c0.478-0.234,0.795-0.824,0.818-1.602c-0.188-0.021-0.272-0.027-0.401-0.027 C18.968,23.08,18.489,23.313,18.323,23.755z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "9.844,18.234 9.409,18.234 7.999,26.659 9.687,26.659 9.771,26.158 8.518,26.158  "
});

var _ref21 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "14.979,19.684 14.18,21.925 13.426,26.659 15.229,26.659 15.312,26.158 13.942,26.158  "
});

var _ref22 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "14.174,18.234 13.74,18.234 12.574,21.71 12.592,22.951  "
});

var _ref23 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "11.291,19.722 10.824,22.488 10.923,26.659 12.151,26.659 12.33,26.158 11.441,26.158  "
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.874,21.375c0-0.455-0.312-0.623-1.155-0.623c-0.883-0.01-1.609,0.21-1.907,0.309c0.013-0.077,0.118-0.734,0.188-1.165 c-0.147,0.038-0.293,0.075-0.458,0.124c0,0-0.232,1.426-0.251,1.539c0.301-0.098,1.027-0.318,1.908-0.307 c0.772,0,1.087,0.153,1.137,0.525c0.147,0.008,0.304,0.021,0.468,0.043C48.86,21.594,48.874,21.497,48.874,21.375z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.468,25.51c0.2,0.77,0.779,1.268,1.565,1.268c0.825,0,1.433-0.268,1.89-0.828l-0.034,0.71h1.492 c0.01-0.104,0.032-0.287,0.062-0.501h-1.035l0.034-0.709c-0.456,0.563-1.064,0.828-1.89,0.828c-0.978,0-1.647-0.763-1.647-1.87 c0-0.614,0.16-1.132,0.46-1.544c-0.456,0.328-0.762,0.781-0.895,1.352c0.075-0.034,0.148-0.063,0.228-0.103L44.468,25.51z"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.07,23.607c-0.014,0.438-0.125,0.813-0.301,1.102c0.478-0.234,0.796-0.823,0.819-1.602 c-0.189-0.021-0.272-0.027-0.402-0.027c-0.815,0-1.294,0.232-1.46,0.675c0.244-0.106,0.543-0.176,0.941-0.176 C47.798,23.579,47.882,23.584,48.07,23.607z"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.073,21.455h0.648l0.074-0.5h-0.642C29.129,21.118,29.102,21.285,29.073,21.455z"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.79,24.773c-0.013-0.304,0.134-1.1,0.248-1.825c0.082-0.503,0.513-3.08,0.696-4.177h-0.434c0,0-0.678,4.035-0.783,4.675 c-0.005,0.029-0.01,0.059-0.014,0.088c0.024,0.145,0.051,0.286,0.051,0.454c0,0.496-0.099,0.898-0.28,1.229 c0,0.015-0.004,0.04-0.003,0.054c0,0.977,0.503,1.506,1.424,1.506c0.418,0,0.803-0.066,1.296-0.223l0.061-0.385 c-0.288,0.064-0.562,0.107-0.836,0.107C27.295,26.277,26.79,25.748,26.79,24.773z"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.481,21.939h0.517c0.01-0.144,0.191-1.223-0.833-1.223c-0.382,0-0.683,0.211-0.896,0.574 c0.116-0.047,0.24-0.075,0.376-0.075C33.256,21.216,33.436,21.6,33.481,21.939z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.718,24.738c0.316,1.334,1.301,2.039,2.929,2.039c0.629,0.002,1.225-0.09,1.841-0.277l0.069-0.396 c-0.459,0.105-0.916,0.175-1.391,0.173c-2.006-0.002-3.052-1.048-3.052-3.055c0-1.215,0.362-2.256,0.959-2.984 c-0.901,0.693-1.478,1.95-1.478,3.483c0,0.303,0.032,0.577,0.079,0.835c0.023-0.006,0.053-0.009,0.074-0.017L29.718,24.738z"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.9,23.818h3.031c0.041-0.179,0.074-0.343,0.104-0.498h-3.153C31.859,23.509,31.871,23.67,31.9,23.818z"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.086,22.174c0.064,0.754,0.475,1.303,1.348,1.715c0.73,0.342,0.843,0.443,0.843,0.754c0,0.027-0.013,0.045-0.016,0.07 c0.36-0.08,0.535-0.262,0.535-0.568c0-0.311-0.112-0.414-0.844-0.756c-0.953-0.449-1.372-1.047-1.372-1.914 c-0.002-0.517,0.121-0.992,0.395-1.381c-0.406,0.262-0.66,0.625-0.794,1.048c0,0.008,0.002,0.015,0.002,0.022 C22.185,21.436,22.143,21.779,22.086,22.174z"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.897,26.076c0.006-0.043,0.085-0.549,0.152-0.979c-0.132-0.032-0.258-0.055-0.396-0.099 c-0.077,0.521-0.139,0.96-0.156,1.159h-0.055c-0.035,0.219-0.063,0.393-0.066,0.416c0.41,0.09,0.775,0.173,1.878,0.203 c1.225,0,2.02-0.305,2.435-0.938c-0.453,0.289-1.081,0.438-1.917,0.438C22.673,26.246,22.306,26.164,21.897,26.076z"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.446,21.309c0.104-0.021,0.222-0.033,0.356-0.033c0.355,0,0.838,0.037,1.297,0.103l0.088-0.547 c-0.314-0.032-0.622-0.056-0.864-0.056C24.755,20.775,24.462,20.959,24.446,21.309z"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.855,24.879c0.031-0.17,0.066-0.338,0.094-0.508c-0.004-0.01-0.009-0.02-0.013-0.029 C39.909,24.521,39.889,24.701,39.855,24.879z"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.731,25.462c0.001,0.001,0.002,0.003,0.003,0.004c0.005-0.022,0.009-0.046,0.014-0.067 C39.743,25.42,39.736,25.44,39.731,25.462z"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.99,19.586c0.021,0.151,0.053,0.298,0.069,0.45C40.043,19.884,40.011,19.737,39.99,19.586z"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.855,24.879c0.033-0.178,0.054-0.357,0.081-0.537c-0.188-0.49-0.299-1.055-0.299-1.699c0-0.895,0.163-1.695,0.433-2.398 c-0.006-0.068-0.004-0.14-0.011-0.208c-0.017-0.152-0.049-0.299-0.069-0.45c-0.013-0.097-0.031-0.192-0.046-0.289 c-0.221,0.387-0.511,1.119-0.669,1.959c-0.53-0.054-0.825,0.152-1.078,0.958c0.105-0.367,0.422-0.492,1.049-0.478 c-0.081,0.446-0.128,0.916-0.128,1.404c0,0.939,0.224,1.72,0.613,2.321c0.005-0.021,0.012-0.042,0.017-0.063 C39.786,25.226,39.822,25.053,39.855,24.879z"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.549,19.259c0.117-0.013,0.238-0.017,0.374,0.008C39.788,19.247,39.662,19.242,39.549,19.259z"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.741,25.699c0.29-1.956,0.647-3.933,0.88-5.891h-0.457c-0.226,2.119-0.627,4.268-0.94,6.39l-0.083,0.461h1.805 c0.027-0.175,0.052-0.337,0.076-0.501H35.66L35.741,25.699z"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.136,20.205c0.325-0.23,0.699-0.369,1.119-0.369c0.502,0,0.967,0.131,1.61,0.457l0.111-0.688 c-0.445-0.187-0.815-0.269-1.203-0.269C43.106,19.336,42.539,19.657,42.136,20.205z"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.949,24.371c-0.027,0.17-0.063,0.338-0.094,0.508c-0.033,0.174-0.069,0.347-0.107,0.52 c-0.005,0.021-0.009,0.045-0.014,0.067c0.54,0.831,1.409,1.312,2.535,1.312c0.499,0,0.93-0.066,1.593-0.246l0.063-0.386 c-0.426,0.095-0.762,0.132-1.138,0.132C41.417,26.277,40.421,25.57,39.949,24.371z"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.99,19.586c0.021,0.151,0.053,0.298,0.069,0.45c0.007,0.065,0.009,0.132,0.016,0.197 c0.373-0.966,0.973-1.716,1.743-2.179c-0.614,0.27-1.157,0.695-1.584,1.283c-0.1-0.033-0.189-0.049-0.278-0.063 c-0.004,0.005-0.007,0.014-0.01,0.019C39.961,19.391,39.978,19.488,39.99,19.586z"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.855,24.879c-0.033,0.174-0.069,0.347-0.107,0.52C39.786,25.226,39.822,25.053,39.855,24.879z"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.075,20.233c-0.007-0.065-0.009-0.132-0.016-0.197c0.007,0.068,0.005,0.14,0.011,0.208 C40.072,20.24,40.073,20.236,40.075,20.233z"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.99,19.586c-0.013-0.098-0.029-0.195-0.044-0.293c-0.001,0.002-0.002,0.003-0.002,0.003 C39.959,19.394,39.978,19.489,39.99,19.586z"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.259,20.926c-0.402,0-0.747,0.232-0.993,0.628c0.146-0.077,0.304-0.128,0.474-0.128c0.619,0,0.954,0.471,0.954,1.342 c0,0.684-0.15,1.265-0.406,1.674c0.561-0.303,0.926-1.109,0.926-2.174C58.213,21.398,57.878,20.926,57.259,20.926z"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.956,18.234H58.52l-0.251,1.525c0.127,0.117,0.25,0.252,0.37,0.41L58.956,18.234z"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.585,25.699c0.289-1.956,0.646-3.933,0.878-5.891h-0.457c-0.226,2.119-0.627,4.268-0.94,6.39l-0.083,0.461h1.804 c0.027-0.175,0.051-0.333,0.076-0.501h-1.36L50.585,25.699z"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.823,25.521c-0.494,0.53-1.001,0.756-1.662,0.756c-1.311,0-2.178-1.129-2.178-2.843c0-1.569,0.646-2.954,1.563-3.673 c-0.564,0.277-1.063,0.808-1.43,1.494c-0.483-0.049-0.771,0.117-1.01,0.758c0.237-0.195,0.475-0.316,0.794-0.301 c-0.275,0.666-0.437,1.435-0.437,2.223c0,1.712,0.865,2.842,2.176,2.842c0.661,0,1.168-0.228,1.664-0.756l-0.085,0.638h1.705 l0.082-0.501h-1.269L57.823,25.521z"
});

var _ref51 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_1"
});

var SvgIconCcMastercardColor = function SvgIconCcMastercardColor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 69.388 43.576",
    style: {
      enableBackground: "new 0 0 69.388 43.576"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "cc-mastercard--color"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, React.createElement("path", {
    style: {
      fill: "#D9222A"
    },
    d: "M19.266,23.579c-0.399,0-0.698,0.069-0.942,0.176c-0.042,0.112-0.078,0.228-0.078,0.368 c0,0.425,0.253,0.698,0.646,0.698c0.172,0,0.33-0.042,0.476-0.112c0.177-0.289,0.288-0.664,0.302-1.102 C19.478,23.584,19.396,23.579,19.266,23.579z"
  }), React.createElement("path", {
    style: {
      fill: "#D9222A"
    },
    d: "M36.262,32.461c0.035-0.042,0.074-0.08,0.108-0.123h-3.353c-0.459-0.557-0.883-1.143-1.268-1.756 h5.865c0.073-0.116,0.144-0.234,0.214-0.353c0.206-0.349,0.4-0.705,0.582-1.07c0.056-0.112,0.109-0.225,0.163-0.338h-7.781 c-0.267-0.569-0.501-1.155-0.702-1.757h9.192c0.022-0.067,0.051-0.133,0.073-0.2c0.047-0.147,0.087-0.298,0.13-0.447 c0.091-0.314,0.173-0.634,0.245-0.955c-0.39-0.602-0.613-1.382-0.613-2.321c0-0.488,0.047-0.958,0.128-1.404 c-0.627-0.015-0.943,0.11-1.049,0.478c-0.23,0.73-0.427,1.954-0.733,3.944h-0.442c-0.024,0.164-0.049,0.326-0.076,0.501h-1.805 l0.083-0.461c0.313-2.122,0.715-4.271,0.94-6.39h0.457c0.021-0.166,0.045-0.333,0.063-0.499h1.656 c0.015,0.348-0.064,0.688-0.108,1.038c0.44-0.647,0.807-1.033,1.317-1.089c0.113-0.017,0.239-0.012,0.374,0.008 c0.006,0.001,0.011-0.001,0.017,0.001c-0.047-0.309-0.085-0.619-0.148-0.922c-0.005-0.025-0.014-0.049-0.019-0.074H29.611 l-0.209,1.038h0.92l-0.245,1.646h-0.281l-0.074,0.5h-0.648c-0.195,1.188-0.425,2.451-0.428,2.641c0,0.354,0.189,0.509,0.617,0.509 c0.171,0,0.301-0.018,0.412-0.048c-0.047-0.258-0.079-0.532-0.079-0.835c0-1.533,0.576-2.79,1.478-3.483 c0.554-0.676,1.308-1.083,2.177-1.083c1.479,0,2.422,0.965,2.422,2.48c0,0.501-0.065,0.993-0.221,1.685h-0.416 c-0.029,0.155-0.063,0.319-0.104,0.498H31.9c0.126,0.632,0.696,0.91,1.541,0.91c0.64,0,1.219-0.133,1.862-0.432l-0.298,1.705 c-0.151,0.046-0.3,0.068-0.449,0.103L34.487,26.5c-0.616,0.188-1.212,0.279-1.841,0.277c-1.628,0-2.612-0.705-2.929-2.039 l-0.206,1.317c-0.168,0.053-0.312,0.081-0.46,0.114l-0.061,0.385c-0.493,0.156-0.878,0.223-1.296,0.223 c-0.921,0-1.424-0.529-1.424-1.506c-0.001-0.014,0.003-0.039,0.003-0.054c-0.14,0.255-0.334,0.462-0.585,0.622 c-0.415,0.633-1.21,0.938-2.435,0.938c-1.103-0.03-1.468-0.113-1.878-0.203c0.004-0.023,0.031-0.197,0.066-0.416h-0.402 c-0.029,0.214-0.053,0.396-0.062,0.501h-1.494l0.034-0.71c-0.456,0.561-1.063,0.828-1.891,0.828c-0.977,0-1.647-0.764-1.647-1.873 c0-0.128,0.02-0.244,0.033-0.363l-0.268,1.617h-0.436l-0.083,0.501h-1.803l0.754-4.734l-1.509,4.233H12.33l-0.179,0.501h-1.229 l-0.099-4.171l-0.619,3.67H9.771l-0.084,0.501H7.999l1.41-8.425h0.435l0.083-0.498h2.593l0.055,3.974l1.166-3.476h0.434 l0.167-0.498h2.8l-1.068,6.455c0.137-0.56,0.439-1.006,0.89-1.328c0.514-0.707,1.441-1.097,2.705-1.097 c0.079,0,0.172,0.005,0.266,0.011c-0.05-0.372-0.363-0.525-1.136-0.525c-0.883-0.012-1.608,0.209-1.908,0.307 c0.02-0.113,0.249-1.539,0.249-1.539c0.166-0.049,0.312-0.086,0.459-0.125c0.035-0.213,0.062-0.375,0.062-0.375 c0.896-0.266,1.491-0.364,2.158-0.364c1.537,0,2.355,0.688,2.364,1.986c0.134-0.423,0.388-0.786,0.794-1.048 c0.397-0.564,1.12-0.938,2.313-0.938c0.413,0,1.12,0.06,1.586,0.134l-0.256,1.59c-0.144-0.021-0.286-0.033-0.431-0.048L26.1,21.378 c-0.459-0.065-0.941-0.103-1.297-0.103c-0.135,0-0.252,0.012-0.356,0.033c0,0.009-0.006,0.016-0.006,0.025 c0,0.321,0.087,0.398,0.843,0.746c0.741,0.342,1.107,0.788,1.221,1.454c0.004-0.029,0.009-0.059,0.014-0.088 c0.105-0.64,0.783-4.675,0.783-4.675h0.434c0.051-0.304,0.084-0.5,0.084-0.5h1.79c0.129-0.598,0.289-1.186,0.482-1.758h9.192 c-0.048-0.144-0.104-0.283-0.155-0.425c-0.134-0.366-0.274-0.729-0.433-1.081c-0.038-0.086-0.082-0.168-0.121-0.252h-7.781 c0.283-0.607,0.604-1.195,0.957-1.76h5.866c-0.04-0.064-0.077-0.131-0.118-0.193c-0.33-0.513-0.682-1.008-1.064-1.48 c-0.022-0.027-0.041-0.058-0.063-0.085h-3.353c0.511-0.62,1.067-1.202,1.663-1.744c-2.947-2.671-6.846-4.312-11.136-4.312 c-9.172,0-16.606,7.436-16.606,16.606s7.435,16.608,16.606,16.608c4.487,0,8.553-1.789,11.542-4.682 c0.102-0.098,0.205-0.195,0.304-0.296C35.693,33.111,35.983,32.791,36.262,32.461z"
  }), React.createElement("path", {
    style: {
      fill: "#D9222A"
    },
    d: "M23.434,23.889c-0.873-0.412-1.283-0.961-1.348-1.715c-0.018,0.117-0.029,0.217-0.05,0.348 c-0.096,0.609-0.259,1.647-0.382,2.478c0.138,0.044,0.264,0.066,0.396,0.099c0.051-0.324,0.095-0.605,0.095-0.605 c0.577,0.188,1.078,0.271,1.615,0.271c0.199,0,0.361-0.02,0.501-0.051c0.003-0.025,0.016-0.043,0.016-0.07 C24.276,24.332,24.164,24.23,23.434,23.889z"
  }), React.createElement("path", {
    style: {
      fill: "#D9222A"
    },
    d: "M33.481,21.939c-0.046-0.34-0.226-0.724-0.836-0.724c-0.136,0-0.26,0.028-0.376,0.075 c-0.105,0.182-0.195,0.388-0.25,0.648H33.481z"
  }), React.createElement("path", {
    style: {
      fill: "#EE9F2D"
    },
    d: "M47.294,24.821c0.171,0,0.33-0.042,0.476-0.112c0.176-0.289,0.287-0.663,0.301-1.102 c-0.188-0.023-0.272-0.028-0.402-0.028c-0.398,0-0.697,0.069-0.941,0.176c-0.042,0.112-0.078,0.228-0.078,0.368 C46.648,24.548,46.899,24.821,47.294,24.821z"
  }), React.createElement("path", {
    style: {
      fill: "#EE9F2D"
    },
    d: "M56.739,21.426c-0.17,0-0.327,0.051-0.474,0.128c-0.255,0.407-0.405,0.988-0.405,1.673 c0,0.896,0.31,1.35,0.924,1.35c0.182,0,0.348-0.053,0.503-0.135c0.256-0.409,0.406-0.99,0.406-1.674 C57.693,21.896,57.358,21.426,56.739,21.426z"
  }), React.createElement("path", {
    style: {
      fill: "#EE9F2D"
    },
    d: "M60.828,25.581c0.018-0.011,0.026-0.032,0.026-0.054c0-0.018-0.012-0.038-0.025-0.049 c-0.021-0.01-0.052-0.008-0.071-0.008h-0.06v0.119h0.063C60.783,25.59,60.807,25.594,60.828,25.581z"
  }), React.createElement("path", {
    style: {
      fill: "#EE9F2D"
    },
    d: "M60.363,25.623c0,0.225,0.184,0.408,0.408,0.408s0.408-0.184,0.408-0.408s-0.184-0.408-0.408-0.408 S60.363,25.398,60.363,25.623z M60.909,25.41c0.038,0.026,0.061,0.07,0.061,0.119c0,0.052-0.032,0.103-0.083,0.12l0.087,0.207 h-0.122l-0.071-0.185h-0.082v0.185h-0.109v-0.47h0.199C60.829,25.387,60.871,25.389,60.909,25.41z"
  }), React.createElement("path", {
    style: {
      fill: "#EE9F2D"
    },
    d: "M38.411,29.159c-0.182,0.365-0.376,0.722-0.582,1.07C38.036,29.881,38.229,29.523,38.411,29.159z"
  }), React.createElement("path", {
    style: {
      fill: "#EE9F2D"
    },
    d: "M39.486,26.417c-0.043,0.149-0.083,0.3-0.13,0.447C39.403,26.717,39.443,26.566,39.486,26.417z"
  }), React.createElement("path", {
    style: {
      fill: "#EE9F2D"
    },
    d: "M35.391,33.419c-0.099,0.101-0.202,0.198-0.304,0.296C35.188,33.617,35.291,33.52,35.391,33.419z"
  }), React.createElement("path", {
    style: {
      fill: "#EE9F2D"
    },
    d: "M39.941,19.268c-0.047-0.309-0.086-0.619-0.15-0.922c0.063,0.303,0.102,0.613,0.148,0.922 C39.94,19.268,39.941,19.268,39.941,19.268z"
  }), React.createElement("path", {
    style: {
      fill: "#EE9F2D"
    },
    d: "M38.695,15.008c0.158,0.353,0.299,0.715,0.433,1.081C38.994,15.723,38.854,15.361,38.695,15.008z"
  }), React.createElement("path", {
    style: {
      fill: "#EE9F2D"
    },
    d: "M36.434,11.322c0.383,0.473,0.734,0.968,1.064,1.48C37.168,12.29,36.816,11.793,36.434,11.322z"
  }), React.createElement("path", {
    style: {
      fill: "#EE9F2D"
    },
    d: "M45.843,5.182c-4.292,0-8.202,1.629-11.149,4.299c-0.005,0.004-0.009,0.009-0.013,0.013 c-0.596,0.542-1.152,1.124-1.663,1.744h3.353h0.002c0.022,0.026,0.039,0.058,0.062,0.085c0.383,0.471,0.734,0.968,1.064,1.48 c0.043,0.066,0.098,0.125,0.14,0.193h-0.021H31.75c-0.353,0.564-0.674,1.152-0.957,1.76h7.781h0.021 c0.038,0.082,0.063,0.17,0.101,0.252c0.158,0.354,0.299,0.715,0.433,1.081c0.053,0.144,0.121,0.278,0.17,0.425h-0.015h-9.192 c-0.193,0.572-0.354,1.16-0.482,1.758h0.003h10.161h0.007c0.005,0.024,0.007,0.05,0.012,0.074c0.064,0.303,0.104,0.613,0.15,0.922 c0.007,0.001,0.012-0.002,0.018,0c-0.001,0.002-0.002,0.005-0.002,0.005c0.088,0.017,0.178,0.032,0.277,0.065 c0.427-0.588,0.97-1.014,1.584-1.283c0.553-0.33,1.181-0.529,1.88-0.529c0.787,0,1.718,0.334,1.982,0.438l-0.297,1.829 c-0.145-0.073-0.278-0.134-0.407-0.188l-0.111,0.688c-0.644-0.326-1.108-0.457-1.61-0.457c-0.42,0-0.794,0.139-1.119,0.369 c-0.41,0.559-0.651,1.352-0.651,2.287c0,1.278,0.635,2.052,1.682,2.052c0.386,0,0.81-0.11,1.304-0.329 c0.133-0.57,0.438-1.023,0.895-1.352c0.514-0.706,1.442-1.097,2.706-1.097c0.079,0,0.172,0.005,0.266,0.011 c-0.05-0.372-0.364-0.525-1.137-0.525c-0.881-0.012-1.607,0.209-1.908,0.307c0.019-0.113,0.251-1.539,0.251-1.539 c0.165-0.049,0.311-0.086,0.458-0.124c0.034-0.214,0.061-0.376,0.061-0.376c0.898-0.266,1.491-0.364,2.158-0.364 c1.548,0,2.368,0.695,2.366,2.009c0.003,0.353-0.055,0.787-0.146,1.357c-0.155,0.992-0.492,3.12-0.537,3.637h-0.459 c-0.029,0.214-0.052,0.396-0.062,0.501h-1.492l0.034-0.71c-0.457,0.561-1.064,0.828-1.89,0.828c-0.786,0-1.365-0.498-1.565-1.268 l-0.086,0.521c-0.165,0.045-0.315,0.082-0.456,0.114l-0.063,0.386c-0.663,0.18-1.094,0.246-1.593,0.246 c-1.126,0-1.995-0.48-2.535-1.312c-0.073,0.321-0.157,0.638-0.248,0.951c-0.043,0.149-0.083,0.3-0.13,0.447 c-0.021,0.065-0.037,0.135-0.059,0.2h-0.015h-9.192c0.201,0.602,0.436,1.188,0.702,1.757h7.781h0.021 c-0.055,0.116-0.126,0.223-0.184,0.338c-0.182,0.364-0.375,0.722-0.582,1.07c-0.067,0.114-0.121,0.239-0.191,0.353h-0.022H31.75 c0.385,0.613,0.809,1.199,1.268,1.756h3.34c-0.033,0.04-0.063,0.084-0.096,0.123c-0.277,0.332-0.568,0.65-0.871,0.958 c-0.1,0.101-0.202,0.198-0.304,0.296c-0.132,0.127-0.258,0.26-0.394,0.383c2.948,2.67,6.857,4.299,11.149,4.299 c9.17,0,16.606-7.438,16.606-16.608S55.013,5.182,45.843,5.182z M59.007,26.158l-0.082,0.501H57.22l0.085-0.638 c-0.496,0.528-1.003,0.756-1.664,0.756c-1.311,0-2.176-1.13-2.176-2.842c0-0.788,0.161-1.557,0.437-2.223 c-0.319-0.016-0.557,0.105-0.794,0.301c-0.262,0.698-0.466,1.961-0.802,4.145h-0.443c-0.025,0.168-0.049,0.326-0.076,0.501h-1.804 l0.083-0.461c0.313-2.122,0.715-4.271,0.94-6.39h0.457c0.02-0.166,0.045-0.333,0.063-0.499h1.656 c0.016,0.348-0.063,0.688-0.108,1.038c0.553-0.811,0.975-1.236,1.729-1.08c-0.224,0.379-0.524,1.13-0.686,1.988 c0.366-0.687,0.865-1.217,1.43-1.494c0.413-0.323,0.877-0.525,1.371-0.525c0.527,0,0.959,0.164,1.351,0.523l0.251-1.525h0.437 l0.082-0.498h1.779l-1.374,8.422H59.007z M60.771,26.158c-0.296,0-0.536-0.239-0.536-0.535c0-0.297,0.24-0.537,0.536-0.537 s0.536,0.24,0.536,0.537C61.308,25.919,61.067,26.158,60.771,26.158z"
  }), _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M16.015,24.541l0.058-0.35C16.045,24.303,16.028,24.421,16.015,24.541z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M14.341,17.736l-0.167,0.498l-1.582,4.717l-0.018-1.241l-0.055-3.974H9.927l-0.083,0.498 l-1.326,7.924h1.253h0.435l0.619-3.67l0.467-2.767l0.15,6.437h0.889h0.341l1.509-4.233l0.799-2.241l-1.036,6.475h1.369h0.436 l0.268-1.617c0.014-0.12,0.03-0.238,0.058-0.35l1.068-6.455H14.341z"
  }), _ref47, _ref48, _ref49, _ref50, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M22.181,21.142c-0.009-1.298-0.827-1.986-2.364-1.986c-0.667,0-1.262,0.099-2.158,0.364 c0,0-0.026,0.162-0.062,0.375c-0.07,0.432-0.177,1.089-0.189,1.166c0.3-0.099,1.027-0.318,1.91-0.309 c0.841,0,1.154,0.168,1.154,0.623c0,0.122-0.014,0.219-0.07,0.445c-0.164-0.021-0.321-0.035-0.469-0.043 c-0.094-0.006-0.187-0.011-0.266-0.011c-1.264,0-2.191,0.39-2.705,1.097c-0.3,0.412-0.46,0.93-0.46,1.544 c0,1.107,0.669,1.87,1.646,1.87c0.827,0,1.435-0.266,1.89-0.828l-0.033,0.709h1.036h0.402h0.055 c0.018-0.199,0.079-0.639,0.156-1.159c0.123-0.83,0.286-1.868,0.382-2.478c0.021-0.131,0.032-0.23,0.05-0.348 c0.057-0.395,0.099-0.738,0.097-1.01C22.183,21.156,22.181,21.149,22.181,21.142z M19.367,24.709 c-0.146,0.07-0.304,0.112-0.476,0.112c-0.394,0-0.646-0.273-0.646-0.698c0-0.141,0.036-0.256,0.078-0.368 c0.166-0.442,0.645-0.675,1.461-0.675c0.129,0,0.213,0.006,0.401,0.027C20.162,23.885,19.845,24.475,19.367,24.709z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M44.468,25.51l0.229-1.397c-0.079,0.039-0.152,0.068-0.228,0.103 c-0.051,0.215-0.084,0.441-0.084,0.689C44.386,25.123,44.419,25.322,44.468,25.51z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M39.949,24.371c0.028-0.182,0.045-0.365,0.066-0.548c-0.021,0.175-0.052,0.346-0.079,0.519 C39.94,24.352,39.945,24.361,39.949,24.371z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M40.153,21.788c0,0.525-0.031,1.044-0.079,1.558C40.122,22.832,40.153,22.314,40.153,21.788z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M40.074,23.346c-0.015,0.16-0.039,0.318-0.059,0.478C40.035,23.664,40.06,23.506,40.074,23.346z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M43.698,17.525c-0.699,0-1.327,0.199-1.88,0.529c-0.771,0.463-1.37,1.213-1.743,2.179 c-0.002,0.003-0.003,0.007-0.005,0.011c-0.27,0.703-0.433,1.504-0.433,2.398c0,0.645,0.11,1.209,0.299,1.699 c0.027-0.173,0.059-0.344,0.079-0.519c-0.021,0.183-0.038,0.366-0.066,0.548c0.472,1.199,1.468,1.906,2.839,1.906 c0.376,0,0.712-0.037,1.138-0.132c0.141-0.032,0.291-0.069,0.456-0.114l0.086-0.521c-0.049-0.188-0.082-0.387-0.082-0.605 c0-0.248,0.033-0.475,0.084-0.689c-0.494,0.219-0.918,0.329-1.304,0.329c-1.047,0-1.682-0.773-1.682-2.052 c0-0.936,0.241-1.729,0.651-2.287c0.403-0.548,0.971-0.869,1.638-0.869c0.388,0,0.758,0.082,1.203,0.269 c0.129,0.054,0.263,0.114,0.407,0.188l0.297-1.829C45.416,17.859,44.485,17.525,43.698,17.525z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M48.219,19.155c-0.667,0-1.26,0.099-2.158,0.364c0,0-0.026,0.162-0.061,0.376 c-0.07,0.431-0.176,1.088-0.188,1.165c0.298-0.099,1.024-0.318,1.907-0.309c0.844,0,1.155,0.168,1.155,0.623 c0,0.122-0.014,0.219-0.07,0.445c-0.164-0.021-0.32-0.035-0.468-0.043c-0.094-0.006-0.187-0.011-0.266-0.011 c-1.264,0-2.192,0.391-2.706,1.097c-0.3,0.412-0.46,0.93-0.46,1.544c0,1.107,0.67,1.87,1.647,1.87c0.825,0,1.434-0.266,1.89-0.828 l-0.034,0.709h1.035h0.459c0.045-0.517,0.382-2.645,0.537-3.637c0.092-0.57,0.149-1.005,0.146-1.357 C50.587,19.851,49.767,19.155,48.219,19.155z M47.77,24.709c-0.146,0.07-0.305,0.112-0.476,0.112c-0.395,0-0.646-0.273-0.646-0.698 c0-0.141,0.036-0.256,0.078-0.368c0.166-0.442,0.645-0.675,1.46-0.675c0.13,0,0.213,0.006,0.402,0.027 C48.565,23.886,48.247,24.475,47.77,24.709z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M29.402,19.31l0.209-1.038h-0.003h-1.79c0,0-0.033,0.196-0.084,0.5 c-0.184,1.097-0.614,3.674-0.696,4.177c-0.114,0.726-0.261,1.521-0.248,1.825c0,0.975,0.505,1.504,1.426,1.504 c0.274,0,0.548-0.043,0.836-0.107c0.148-0.033,0.292-0.062,0.46-0.114l0.206-1.317c-0.015-0.061-0.031-0.118-0.043-0.182 c-0.111,0.03-0.241,0.048-0.412,0.048c-0.428,0-0.617-0.155-0.617-0.509c0.003-0.189,0.232-1.453,0.428-2.641 c0.028-0.17,0.056-0.337,0.081-0.5h0.642h0.281l0.245-1.646H29.402z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M29.749,24.54c-0.021,0.008-0.051,0.011-0.074,0.017c0.012,0.063,0.028,0.121,0.043,0.182 L29.749,24.54z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M35.451,23.32c0.155-0.691,0.221-1.184,0.221-1.685c0-1.516-0.943-2.48-2.422-2.48 c-0.869,0-1.623,0.407-2.177,1.083c-0.597,0.729-0.959,1.77-0.959,2.984c0,2.007,1.046,3.053,3.052,3.055 c0.475,0.002,0.932-0.067,1.391-0.173c0.149-0.034,0.298-0.057,0.449-0.103l0.298-1.705c-0.644,0.299-1.223,0.432-1.862,0.432 c-0.845,0-1.415-0.278-1.541-0.91c-0.029-0.148-0.041-0.31-0.019-0.498h3.153H35.451z M33.998,21.939h-0.517H32.02 c0.055-0.261,0.145-0.467,0.25-0.648c0.213-0.363,0.514-0.574,0.896-0.574C34.189,20.717,34.008,21.796,33.998,21.939z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M25.323,20.775c0.242,0,0.55,0.023,0.864,0.056c0.145,0.015,0.287,0.027,0.431,0.048l0.256-1.59 c-0.466-0.074-1.173-0.134-1.586-0.134c-1.193,0-1.916,0.374-2.313,0.938c-0.273,0.389-0.396,0.864-0.395,1.381 c0,0.867,0.419,1.465,1.372,1.914c0.731,0.342,0.844,0.445,0.844,0.756c0,0.307-0.175,0.488-0.535,0.568 c-0.14,0.031-0.302,0.051-0.501,0.051c-0.537,0-1.038-0.083-1.615-0.271c0,0-0.044,0.281-0.095,0.605 c-0.067,0.43-0.146,0.936-0.152,0.979c0.408,0.088,0.775,0.17,1.875,0.201c0.836,0,1.464-0.148,1.917-0.438 c0.251-0.16,0.445-0.367,0.585-0.622c0.182-0.331,0.28-0.733,0.28-1.229c0-0.168-0.026-0.31-0.051-0.454 c-0.113-0.666-0.479-1.112-1.221-1.454c-0.756-0.348-0.843-0.425-0.843-0.746c0-0.01,0.006-0.017,0.006-0.025 C24.462,20.959,24.755,20.775,25.323,20.775z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M59.038,17.736l-0.082,0.498l-0.317,1.936c-0.12-0.158-0.243-0.293-0.37-0.41 c-0.392-0.359-0.823-0.523-1.351-0.523c-0.494,0-0.958,0.202-1.371,0.525c-0.918,0.719-1.563,2.104-1.563,3.673 c0,1.714,0.867,2.843,2.178,2.843c0.661,0,1.168-0.226,1.662-0.756l-0.085,0.637h1.269h0.437l1.374-8.422H59.038z M57.287,24.441 c-0.155,0.082-0.321,0.135-0.503,0.135c-0.614,0-0.924-0.453-0.924-1.35c0-0.685,0.15-1.266,0.405-1.673 c0.246-0.396,0.591-0.628,0.993-0.628c0.619,0,0.954,0.473,0.954,1.342C58.213,23.332,57.848,24.139,57.287,24.441z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M53.073,20.348c0.045-0.351,0.124-0.69,0.108-1.038h-1.656c-0.018,0.166-0.043,0.333-0.063,0.499 c-0.232,1.958-0.589,3.935-0.878,5.891l-0.083,0.459h1.36h0.443c0.336-2.184,0.54-3.446,0.802-4.145 c0.239-0.641,0.526-0.807,1.01-0.758c0.161-0.858,0.462-1.609,0.686-1.988C54.048,19.111,53.626,19.537,53.073,20.348z  M52.582,20.84v-0.007h0.001C52.583,20.833,52.582,20.838,52.582,20.84z"
  }), React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "52.582,20.84 52.582,20.836 52.582,20.833  "
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M39.939,19.268c-0.006-0.002-0.011,0-0.017-0.001c0.006,0.001,0.012,0.003,0.017,0.004V19.268z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M39.956,19.274c0,0,0.002-0.005,0.003-0.007c-0.006-0.002-0.011,0.001-0.018,0 c0.001,0.001,0.001,0.002,0.001,0.002C39.946,19.271,39.951,19.273,39.956,19.274z"
  }), React.createElement("rect", {
    x: 39.939,
    y: 19.267,
    style: {
      fill: "#FFFFFF"
    },
    width: 0.003,
    height: 0.004
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M39.939,19.271c-0.005-0.001-0.011-0.003-0.017-0.004c-0.136-0.024-0.257-0.021-0.374-0.008 c-0.511,0.056-0.877,0.441-1.317,1.089c0.044-0.351,0.123-0.69,0.108-1.038h-1.656c-0.018,0.166-0.042,0.333-0.063,0.499 c-0.232,1.958-0.59,3.935-0.88,5.891l-0.081,0.459h1.361h0.442c0.307-1.99,0.503-3.214,0.733-3.944 c0.253-0.806,0.548-1.012,1.078-0.958c0.158-0.84,0.448-1.572,0.669-1.959C39.942,19.288,39.941,19.279,39.939,19.271z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M39.946,19.293c0.003-0.005,0.006-0.014,0.01-0.019c-0.005-0.001-0.01-0.003-0.014-0.003 C39.943,19.279,39.945,19.286,39.946,19.293z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M39.946,19.293c-0.001-0.007-0.003-0.014-0.004-0.021c-0.001,0-0.002-0.001-0.003-0.001 c0.002,0.009,0.003,0.018,0.005,0.026C39.944,19.297,39.945,19.295,39.946,19.293z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M60.235,25.623c0,0.296,0.24,0.535,0.536,0.535s0.536-0.239,0.536-0.535 c0-0.297-0.24-0.537-0.536-0.537S60.235,25.326,60.235,25.623z M61.18,25.623c0,0.225-0.184,0.408-0.408,0.408 s-0.408-0.184-0.408-0.408s0.184-0.408,0.408-0.408S61.18,25.398,61.18,25.623z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M60.589,25.856h0.109v-0.185h0.082l0.071,0.185h0.122l-0.087-0.207 c0.051-0.018,0.083-0.068,0.083-0.12c0-0.049-0.022-0.093-0.061-0.119c-0.038-0.021-0.08-0.023-0.121-0.023h-0.199V25.856z  M60.698,25.471h0.06c0.02,0,0.051-0.002,0.071,0.008c0.014,0.011,0.025,0.031,0.025,0.049c0,0.021-0.009,0.043-0.026,0.054 c-0.021,0.013-0.045,0.009-0.067,0.009h-0.063V25.471z"
  })), _ref51);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconCcMastercardColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cc-mastercard--color.81a40f54.svg";
export { ForwardRef as ReactComponent };